import { render, staticRenderFns } from "./ProfileSimulation.vue?vue&type=template&id=d244c934&"
import script from "./ProfileSimulation.vue?vue&type=script&lang=ts&"
export * from "./ProfileSimulation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports